import styled from 'styled-components'
interface IProps {
  checked?: boolean
  disabled?: boolean
  color: string
}

export const Container = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 8px;
  * {
    cursor: pointer;
  }
`
export const Label = styled.span<IProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.colors.color2d3139};
  font-size: 15px;
  margin-left: 8px;
  svg {
    fill: ${props => (props?.color ? props.color : '#000')};
    font-size: 18px;
    margin-right: 8px;
  }
`
